import React from 'react';
import styled from 'styled-components';
import { PostSocialLinks } from './PostSocialLinks';

const PostFooterContainer = styled.div`
    p {
        font-size: 19px;
        line-height: 1.21053;
        font-weight: 800;
        letter-spacing: -0.02em;
        margin: 0;
    }
    margin-left: auto;
    margin-right: auto;
    margin-top: 32px;
    margin-bottom: 32px;
`;

export const PostFooter = ({ socialLinks }) => {
    return (
        <PostFooterContainer className='component-content'>
            <p>Artikel teilen</p>
            <PostSocialLinks socialLinks={socialLinks} />
        </PostFooterContainer>
    );
};
